import React from 'react'
import { api } from 'utils'
import { PAGINEDETAIL } from 'utils/endpoint'
import MetaSeo from 'components/atomic/MetaSeo'
import CartTemplate from 'react-components/templates/CartTemplate/CartTemplate'
import { useWishlistQuery } from 'gql/graphql'
import { getPromoAdapted } from '../../utils/cart'

function Cart({ pagina }) {
  const { data } = useWishlistQuery({ fetchPolicy: 'network-only' })

  return (
    <>
      <MetaSeo seo={pagina.seo} />
      <CartTemplate wishlist={data?.wishlist ? getPromoAdapted(data?.wishlist) : {}} />
    </>
  )
}

export const getStaticProps = async () => {
  const pageResponse = await api.get(PAGINEDETAIL, {
    params: {
      chiave: 'cart',
    },
  })
  const pagina = await pageResponse.data
  const toolbarProps = { toolbarPage: pagina }

  return { props: { pagina, ...toolbarProps }, revalidate: 60 * 60 }
}

export default Cart
